// extracted by mini-css-extract-plugin
export default {"container":"CounterBox_container__hk5TX","text":"CounterBox_text__jpr8Z","counter":"CounterBox_counter__aXsN3","visual":"CounterBox_visual__0auoq"};